import axios from "axios";
import store from "@/store/store";
// import Cookies from 'js-cookie'
// import { Constant } from '../common/constant'

// const TOKEN_NAME = Constant.TOKEN_NAME
// const TOKEN_TEMP_NAME = Constant.TOKEN_TEMP_NAME
// const CSRF_COOKIE_NAME = "csrftoken";
// const CSRF_HEADER_NAME = "X-CSRFToken";

// const session = axios.create({
//   xsrfCookieName: CSRF_COOKIE_NAME,
//   xsrfHeaderName: CSRF_HEADER_NAME,
//   timeout: 60000
// });
// axios.post(
// const token = localStorage.getItem("delivery_token")? localStorage.getItem("delivery_token"): "";
// console.log(token)
// if (token) {
//   session.defaults.headers["Authorization"] =
//     "Bearer " + localStorage.getItem("delivery_token");
// }
const session =  function(){
  const CSRF_COOKIE_NAME = "csrftoken";
  const CSRF_HEADER_NAME = "X-CSRFToken";
  const token = store.state.auth?.token;
  if(token){
    return axios.create({
      xsrfCookieName: CSRF_COOKIE_NAME,
      xsrfHeaderName: CSRF_HEADER_NAME,
      headers: {Authorization: "Bearer " + token},
      timeout: 60000
    });
  }
  
 
  return axios.create({
    xsrfCookieName: CSRF_COOKIE_NAME,
    xsrfHeaderName: CSRF_HEADER_NAME,
    timeout: 60000
  });
}

// let tokenTemp = Cookies.get(TOKEN_TEMP_NAME)
// if (tokenTemp) {
//   session.defaults.headers['token'] = tokenTemp
// } else {
//   let token = Cookies.get(TOKEN_NAME)
//   if (token) {
//     token = JSON.parse(token)
//     session.defaults.headers['token'] = `${token.access_token}`
//   }
// }
// debugger
// if (store.state.auth.token) {
//   sessionAuth.defaults.headers['Authorization'] = 'Bearer ' + store.state.auth.token;
// } else {
//   sessionAuth.defaults.headers['Authorization'] = '';
// }

export default session;
